export * from './htmlToMarkdown'
export * from './tailwindData'

export const removeSlashes = (string: string): string =>
  string.replace(/^\/|\/$/g, '')
